<template>
  <master-main
    :addProperties="{
      eventType: 1,
      routeToCreate: getModuleRoute,
    }"
    :dataBadges="[
      {
        columnLabel: $t('common_words.associated_companies2'),
        data: 'businesses',
        property: 'name',
        minWidth: 160,
      },
      {
        columnLabel: $t('common_words.farm'),
        data: 'farms',
        property: 'name',
        minWidth: 160,
      },
    ]"
    :route="getModuleRoute"
    :showProperties="showProperties"
    :tableProperties="tableProperties"
    @refresh="refresh"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
    :showExportTables="false"
  >
  </master-main>
</template>
<script>
import { getDateToday } from 'src/util/Util';
import ValvesTable from 'src/views/Pages/Dashboard/IrrigationReading/Valves/valve-table.js';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import { MixinExport } from 'src/mixins/mixin-export';

export default {
  components: { MasterMain },
  data() {
    return {
      tableProperties: {},
      showProperties: { size: '60%' },
    };
  },
  mixins: [
    MixinAlert,
    MixinLoading,
    MixinForm,
    MixinMain,
    MixinPermissions,
    MixinMenu,
    MixinExport,
  ],
  computed: {
    getModuleRoute() {
      return 'irrigation/valves';
    },
    buildTableProperties() {
      return {
        tableColumns: [...ValvesTable().tableColumns],
        model: 'valves',
        effectTags: 'dark',
        defaultSort: { prop: 'name', order: 'ascending' },
      };
    },
    dateToday() {
      return getDateToday();
    },
  },
};
</script>
